import styled from '@emotion/styled'
import { useMemo, useState } from 'react'
import { useTheme } from '@emotion/react'

import SelectBase, * as Select from '@segment/matcha/components/Select'
import Input from '@segment/matcha/components/Input'
import { ChevronDownIcon, ClearIcon } from '@segment/matcha/components/Icons/Common'

import type { SelectState } from '@segment/matcha/components/Select/useSelect'
import useSelect from '@segment/matcha/components/Select/useSelect'

import { scrollToAnchor } from '@segment/utils/useScrollToAnchor'

const options = [
  {
    value: `introduction`,
    text: `Introduction`,
  },
  {
    value: `keyFindings`,
    text: `Key Findings`,
  },
  {
    value: `ourTake`,
    text: `Our take`,
  },
  {
    value: `methodology`,
    text: `Methodology`,
  },
]

const MobileSelect = () => {
  const [categoryId, setCategoryId] = useState(`jump`)
  const theme = useTheme()

  const option = useMemo(
    () => options.find((o) => o.value === categoryId) ?? { value: `jump`, text: `Jump to section` },
    [categoryId]
  )

  const useControlledState = (state: SelectState): SelectState => ({
    ...state,
    selected: [option],
  })

  const { state, getControlProps, filteredOptions, getSelectProps } = useSelect({
    initialSelected: [option],
    useControlledState,
    options,
    id: `jump-to-section`,
    onSelect(o) {
      scrollToAnchor(o[0].value, -100)
      setCategoryId(o[0].value)
    },
    config: {
      mobileConfirmationBehaviour: false,
    },
    label: `Jump to section`,
  })

  return (
    <Wrapper>
      <Input
        name="jump-to-section"
        type="search"
        resetable={state.filterValue !== ``}
        expanded={true}
        clearIcon={
          <Select.ClearSelect>
            <ClearIcon size="small" color={theme.palette.neutrals.white[100]} />
          </Select.ClearSelect>
        }
        rightSecondIcon={<ChevronDownIcon />}
        {...getControlProps({ placeholder: `Jump to section...` })}
      />
      <SelectBase
        id="sections-dropdown"
        name="select-section"
        options={options}
        filteredOptions={filteredOptions}
        displayMode={state.displayMode}
        open={state.open}
        modalHeadline="Jump to section"
        {...getSelectProps()}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div``

export default MobileSelect
